import { SupplyWalkParams } from "./default_config";

export const paramsToTransformArgs = (
  params: SupplyWalkParams
): Record<
  string,
  | string
  | string[]
  | Date
  | [string, string, string[] | string][]
  | null
  | boolean
> => {
  return {
    min_date: params.minDate ?? null,
    max_date: params.maxDate ?? null,
    date_field: params.dateHierarchy,
    segmentation_fields: params.segments ?? [],
    filters: params.filters,
    post_filters: params.postFilters ?? [],
    include_atomic_purchase_plan: params.includeAtomicPurchasePlan,
  };
};
